<datex-grid #$gridComponent *ngIf="initialized && !$hasMissingRequiredInParams" [selection]="true" (selectionChange)="$selectionChanged($event)" [headers]="headers" [rows]="rows" [(pageSize)]="pageSize" [(pageSkip)]="pageSkip" [totalCount]="totalCount" [loadingStatus]="loadingStatus" (pageChange)="$dataLoad()" [containerStyles]="containerStyles"
[canEdit]="canEdit"


>
    <ng-container topToolbar>
    <div class="query-filter">
      <input
        matInput
        [(ngModel)]="fullTextSearch" 
        (ngModelChange)="reload()" 
        [ngModelOptions]="{updateOn: 'blur'}"
        autocomplete="off"
        class="datex-textbox query-search"
        spellcheck="false"
        placeholder="Filter"
        [matTooltip]="fullTextSearch"
        matTooltipClass="datex-control-tooltip">
    </div>
  </ng-container>

  <ng-container filters>
    <div class="fieldsetsContainer" [formGroup]="formGroup">
      <div class="fieldsetsGroup">
      <div data-cy="field-id-produced_on_or_after" *ngIf="!filters.produced_on_or_after.hidden && !filters.produced_on_or_after.removed" 
            class="field-container standard {{filters.produced_on_or_after.invalid ? 'invalid' : ''}} {{filters.produced_on_or_after.control.disabled ? 'field-container-disabled' : ''}}"
            [ngStyle]="filters.produced_on_or_after.styles.style"
            [ngClass]="filters.produced_on_or_after.styles.classes">
        <div class="label-container"
             [matTooltip]="filters.produced_on_or_after.label + (filters.produced_on_or_after.required ? ' (required)' : '')"
             matTooltipClass="datex-control-tooltip">
          <label data-cy="field-label" class="datex-label">{{filters.produced_on_or_after.label}}<span *ngIf="filters.produced_on_or_after.required" class="required-asterisk">*</span>
          </label>
        </div>
        <app-datebox 
            data-cy="dateBox"
            formControlName="produced_on_or_after"
            [format]="filters.produced_on_or_after.control.format"
            [mode]="filters.produced_on_or_after.control.mode"
            [ngStyle]="filters.produced_on_or_after.control.styles.style"
            [ngClass]="filters.produced_on_or_after.control.styles.classes"
            [tooltip]="filters.produced_on_or_after.control.tooltip">
        </app-datebox>
        <ng-container *ngIf="filters.produced_on_or_after.invalid">
          <ng-container *ngFor="let error of filters.produced_on_or_after.errors">
            <span class="invalid-message">
              {{error}}
            </span>
          </ng-container>
        </ng-container>
      </div>      <div data-cy="field-id-expires_before" *ngIf="!filters.expires_before.hidden && !filters.expires_before.removed" 
            class="field-container standard {{filters.expires_before.invalid ? 'invalid' : ''}} {{filters.expires_before.control.disabled ? 'field-container-disabled' : ''}}"
            [ngStyle]="filters.expires_before.styles.style"
            [ngClass]="filters.expires_before.styles.classes">
        <div class="label-container"
             [matTooltip]="filters.expires_before.label + (filters.expires_before.required ? ' (required)' : '')"
             matTooltipClass="datex-control-tooltip">
          <label data-cy="field-label" class="datex-label">{{filters.expires_before.label}}<span *ngIf="filters.expires_before.required" class="required-asterisk">*</span>
          </label>
        </div>
        <app-datebox 
            data-cy="dateBox"
            formControlName="expires_before"
            [format]="filters.expires_before.control.format"
            [mode]="filters.expires_before.control.mode"
            [ngStyle]="filters.expires_before.control.styles.style"
            [ngClass]="filters.expires_before.control.styles.classes"
            [tooltip]="filters.expires_before.control.tooltip">
        </app-datebox>
        <ng-container *ngIf="filters.expires_before.invalid">
          <ng-container *ngFor="let error of filters.expires_before.errors">
            <span class="invalid-message">
              {{error}}
            </span>
          </ng-container>
        </ng-container>
      </div>      </div>
    </div>
  </ng-container>

  <ng-container gridColumnDef="status">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.status.displayControl.styles.style"
          [ngClass]="row.cells.status.displayControl.styles.classes"
          [matTooltip]="row.cells.status.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.status.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="lot">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.lot.displayControl.styles.style"
          [ngClass]="row.cells.lot.displayControl.styles.classes"
          [matTooltip]="row.cells.lot.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.lot.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="vendor_lot">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.vendor_lot.displayControl.styles.style"
          [ngClass]="row.cells.vendor_lot.displayControl.styles.classes"
          [matTooltip]="row.cells.vendor_lot.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.vendor_lot.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="packaging">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.packaging.displayControl.styles.style"
          [ngClass]="row.cells.packaging.displayControl.styles.classes"
          [matTooltip]="row.cells.packaging.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.packaging.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="weight">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.weight.displayControl.styles.style"
          [ngClass]="row.cells.weight.displayControl.styles.classes"
          [matTooltip]="row.cells.weight.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.weight.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="available">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.available.displayControl.styles.style"
          [ngClass]="row.cells.available.displayControl.styles.classes"
          [matTooltip]="row.cells.available.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.available.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="production_date">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.production_date.displayControl.styles.style"
          [ngClass]="row.cells.production_date.displayControl.styles.classes"
          [matTooltip]="row.cells.production_date.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.production_date.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="expiration_date">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.expiration_date.displayControl.styles.style"
          [ngClass]="row.cells.expiration_date.displayControl.styles.classes"
          [matTooltip]="row.cells.expiration_date.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.expiration_date.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="full_quantity">

    <ng-template gridCellDisplayControlDef let-row>
    <mat-checkbox data-cy="checkBox" [formControl]="row.formGroup.controls['full_quantity_display']"
                  class="datex-checkbox"
                  color="primary"
                  [ngStyle]="row.cells.full_quantity.displayControl.styles.style"
                  [ngClass]="row.cells.full_quantity.displayControl.styles.classes"
                  [matTooltip]="row.cells.full_quantity.displayControl.tooltip"
                  matTooltipClass="datex-control-tooltip">{{row.cells.full_quantity.displayControl.label}}</mat-checkbox>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <mat-checkbox data-cy="checkBox" [formControl]="row.formGroup.controls['full_quantity_edit']"
                  class="datex-checkbox"
                  color="primary"
                  [ngStyle]="row.cells.full_quantity.editControl.styles.style"
                  [ngClass]="row.cells.full_quantity.editControl.styles.classes"
                  [matTooltip]="row.cells.full_quantity.editControl.tooltip"
                  matTooltipClass="datex-control-tooltip">{{row.cells.full_quantity.editControl.label}}</mat-checkbox>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="quantity_to_transform">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.quantity_to_transform.displayControl.styles.style"
          [ngClass]="row.cells.quantity_to_transform.displayControl.styles.classes"
          [matTooltip]="row.cells.quantity_to_transform.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.quantity_to_transform.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <input data-cy="numberBox" [formControl]="row.formGroup.controls['quantity_to_transform_edit']"
            matInput
            numberBox
            [format]="row.cells.quantity_to_transform.editControl.format"
            autocomplete="off"
            spellcheck="false"
            class="datex-numberbox {{ (row.cells.quantity_to_transform.editControl.readOnly || row.cells.quantity_to_transform.editControl.disabled) ? 'readonly ' : ''}}"
            placeholder="{{row.cells.quantity_to_transform.editControl.placeholder}}"
            [ngStyle]="row.cells.quantity_to_transform.editControl.styles.style"
            [ngClass]="row.cells.quantity_to_transform.editControl.styles.classes"
            [matTooltip]="row.cells.quantity_to_transform.editControl.tooltip"
            matTooltipClass="datex-control-tooltip">
    </ng-template>

  </ng-container>

<ng-container bottomToolbar>
</ng-container>


</datex-grid>
<div *ngIf="$hasMissingRequiredInParams" class="missing-params">
  <h3>Please provide {{$missingRequiredInParams.toString()}}</h3>
</div>
